import { useMemo } from "react";

import { UserRole } from "@/api/generated.schemas";
import { NavigationItem, searchNavigation } from "@/utils/navigationSearchItems";

/**
 * Hook for client-side navigation search.
 * Filters navigation items instantly without API calls.
 *
 * @param query - Search query string
 * @param userRole - Current user's role for permission filtering
 * @returns Matching navigation items
 */
export function useNavigationSearch(query: string, userRole: UserRole): NavigationItem[] {
  return useMemo(() => {
    return searchNavigation(query, userRole);
  }, [query, userRole]);
}
